import { Component, OnInit } from '@angular/core';
import { PurchaseService } from '../../purchase/purchase.service';
import { Observable } from 'rxjs';
import { Store } from '../store';
import { share } from 'rxjs/operators';
import { StoreService } from '../store.service';

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss'],
})
export class SalesComponent implements OnInit {
  store$: Observable<Store> | undefined = undefined;

  constructor(
    readonly purchaseService: PurchaseService,
    private readonly storeService: StoreService
  ) {}

  ngOnInit(): void {
    this.store$ = this.getUserStore();
  }

  private getUserStore(): Observable<Store> {
    return this.storeService.getUserStore().pipe(share());
  }
}
